import React, { Component } from "react";
import { connect } from "react-redux";
import LOOKUP from "constants/lookup";
import GenericTable from "screens/components/advanced/GenericTable";
import Pagination from "screens/components/basic/Pagination";
import CardSimple from "screens/components/basic/CardSimple";
import { getRoles, deleteRole } from "actions/EntityActions";
import { userRoleListCrumb } from "utils/breadcrumbInfo";
import { mapRolesList } from "utils/mappers";
import Grid from "screens/components/basic/Grid";
import Button from "screens/components/basic/Button";
import DialogInput from "screens/components/advanced/DialogInput";
import WithRouter from "custom/withRouter";
import PageHeaderWithButton from "screens/components/basic/PageHeaderWithButton";
import DialogHeaderWithClose from '../../../components/basic/DialogHeaderWithClose';

const pageName = "userRoleList";
class UserRoleList extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      activePage: 1,
      itemsPerPage: 25,
      status: "None",
      orderBy: "DESC",
      sortBy: "Id",
      openDeleteDialog: false
    };
    this.editUserRole = this.editUserRole.bind(this);
  }

  //Call the init which will call API to retrive the list of patients
  componentWillMount() {
    this.props.getRoles();
  }

  componentDidUpdate(prevProps) {
    if (this.props.saveSuccess && this.props.saveSuccess != prevProps.saveSuccess) {
      window.location.reload();
    }
  }

  getRoles = () => {
    this.props.init({
      page: this.state.activePage,
      itemsPerPage: this.state.itemsPerPage,
      orderBy: this.state.orderBy,
      sortBy: this.state.sortBy
    });
  }

  createNewRole = () => {
    window.location = `/userrole/add`;
  }

  editUserRole = (id) => {
    window.location = `/userrole/edit/${id}`;
  };

  closeDeleteRoleDialog = () => {
    this.setState({
      openDeleteDialog: false
    })
  }

  confirmDeleteRole = (id) => {
    this.setState({
      openDeleteDialog: true,
      selectedRoleId: id
    })
  }

  deleteRole = () => {
    this.props.deleteRole(this.state.selectedRoleId);
  }

  render() {
    const p = this.props;
    const s = this.state;
    return (
      <Grid headerContent={userRoleListCrumb}>
        <PageHeaderWithButton title={LOOKUP.userRole.listTitle}>
          <Button
            style={{ marginLeft: "1em" }}
            type="AddButton"
            mini={true}
            label="ADD NEW ROLE"
            className="bg-light-green"
            onTouchTap={() => window.location = "/userrole/add"}
          />
        </PageHeaderWithButton>
        <CardSimple>
          <GenericTable
            multiSelectable={false}
            enableSelectAll={false}
            selectable={false}
            columns={LOOKUP.userRole.tableColumns}
            rows={mapRolesList(p.rolesList, this.editUserRole, this.confirmDeleteRole)}
            orderBy={this.state.orderBy}
            sortBy={this.state.sortBy}
            sort={this.sort}
            stripedRows={true}
          />
          <Pagination
            length={p.rolesList ? p.rolesList.length : 0}
            itemsPerPage={s.itemsPerPage}
            activePage={s.activePage}
            onPageChange={this.changePage}
            maxButtons={4}
          />
        </CardSimple>
        <DialogInput
          title={<DialogHeaderWithClose text="Delete Role" classicClass="posDialogClassic" handleClose={() => this.closeDeleteRoleDialog()} />}
          actions={[
            <Button
              key={1}
              type="CancelButton"
              name="buttonCancelRemoveItem"
              className="btn-space btnCancelOperation"
              label={LOOKUP.common.cancel.text}
              onTouchTap={() => this.closeDeleteRoleDialog()} />,
            <Button
              key={2}
              name="buttonRemoveItem"
              label="Confirm"
              className="btnNewBrandPOS"
              primary={true}
              onTouchTap={() => this.deleteRole()} />]}
          modal={true}
          open={this.state.openDeleteDialog}>
          Are you sure you want to delete the role?
        </DialogInput>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    rolesList: state.entity.rolesList ? state.entity.rolesList.filter(_ => _.name != "StoreOwner") : [],
    saveSuccess: state.entity.saveSuccess || null,
    saveError: state.entity.saveError || null
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getRoles: () => dispatch(getRoles()),
    deleteRole: (id) => dispatch(deleteRole(id))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(UserRoleList));
